// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApierrorsError,
  ResponseActionAck,
  ResponseClusterRollout,
  ResponseClusterRolloutList,
  ResponseRollout,
  ResponseRolloutSummaryList,
  ResponseRolloutUnavailable,
  ServerApproveRolloutRequest,
  ServerSkipCooldownRolloutRequest,
} from '../models/index';
import {
  ApierrorsErrorFromJSON,
  ApierrorsErrorToJSON,
  ResponseActionAckFromJSON,
  ResponseActionAckToJSON,
  ResponseClusterRolloutFromJSON,
  ResponseClusterRolloutToJSON,
  ResponseClusterRolloutListFromJSON,
  ResponseClusterRolloutListToJSON,
  ResponseRolloutFromJSON,
  ResponseRolloutToJSON,
  ResponseRolloutSummaryListFromJSON,
  ResponseRolloutSummaryListToJSON,
  ResponseRolloutUnavailableFromJSON,
  ResponseRolloutUnavailableToJSON,
  ServerApproveRolloutRequestFromJSON,
  ServerApproveRolloutRequestToJSON,
  ServerSkipCooldownRolloutRequestFromJSON,
  ServerSkipCooldownRolloutRequestToJSON,
} from '../models/index';

export interface OperatorsOperatorNameRolloutsRolloutIdentifierAbortPutRequest {
  operatorName: string;
  rolloutIdentifier: string;
}

export interface OperatorsOperatorNameRolloutsRolloutIdentifierApprovePutRequest {
  operatorName: string;
  rolloutIdentifier: string;
  request: ServerApproveRolloutRequest;
}

export interface OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsClusterNameGetRequest {
  operatorName: string;
  rolloutIdentifier: string;
  clusterName: string;
}

export interface OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetRequest {
  operatorName: string;
  rolloutIdentifier: string;
  limit?: number;
  cursor?: string;
  pendingActions?: boolean;
  propagationFailing?: boolean;
  stepPhase?: Array<OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetStepPhaseEnum>;
  step?: Array<string>;
  cluster?: Array<string>;
  condition?: Array<string>;
}

export interface OperatorsOperatorNameRolloutsRolloutIdentifierGetRequest {
  operatorName: string;
  rolloutIdentifier: string;
}

export interface OperatorsOperatorNameRolloutsRolloutIdentifierPausePutRequest {
  operatorName: string;
  rolloutIdentifier: string;
}

export interface OperatorsOperatorNameRolloutsRolloutIdentifierResumePutRequest {
  operatorName: string;
  rolloutIdentifier: string;
}

export interface OperatorsOperatorNameRolloutsRolloutIdentifierSkipCooldownPutRequest {
  operatorName: string;
  rolloutIdentifier: string;
  request: ServerSkipCooldownRolloutRequest;
}

/**
 *
 */
export class RolloutApi extends runtime.BaseAPI {
  /**
   * Record a request to abort a rollout; a background reconciler applies it to every orchestra that has it
   * Abort a rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierAbortPutRaw(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierAbortPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseActionAck>> {
    if (requestParameters['operatorName'] == null) {
      throw new runtime.RequiredError(
        'operatorName',
        'Required parameter "operatorName" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierAbortPut().',
      );
    }

    if (requestParameters['rolloutIdentifier'] == null) {
      throw new runtime.RequiredError(
        'rolloutIdentifier',
        'Required parameter "rolloutIdentifier" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierAbortPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/operators/{operatorName}/rollouts/{rolloutIdentifier}/abort`;
    urlPath = urlPath.replace(
      `{${'operatorName'}}`,
      encodeURIComponent(String(requestParameters['operatorName'])),
    );
    urlPath = urlPath.replace(
      `{${'rolloutIdentifier'}}`,
      encodeURIComponent(String(requestParameters['rolloutIdentifier'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseActionAckFromJSON(jsonValue),
    );
  }

  /**
   * Record a request to abort a rollout; a background reconciler applies it to every orchestra that has it
   * Abort a rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierAbortPut(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierAbortPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseActionAck> {
    const response =
      await this.operatorsOperatorNameRolloutsRolloutIdentifierAbortPutRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Record a request to approve the given RequireApproval step of a rollout; a background reconciler applies it to every orchestra that has it
   * Approve a rollout step
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierApprovePutRaw(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierApprovePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseActionAck>> {
    if (requestParameters['operatorName'] == null) {
      throw new runtime.RequiredError(
        'operatorName',
        'Required parameter "operatorName" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierApprovePut().',
      );
    }

    if (requestParameters['rolloutIdentifier'] == null) {
      throw new runtime.RequiredError(
        'rolloutIdentifier',
        'Required parameter "rolloutIdentifier" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierApprovePut().',
      );
    }

    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierApprovePut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/operators/{operatorName}/rollouts/{rolloutIdentifier}/approve`;
    urlPath = urlPath.replace(
      `{${'operatorName'}}`,
      encodeURIComponent(String(requestParameters['operatorName'])),
    );
    urlPath = urlPath.replace(
      `{${'rolloutIdentifier'}}`,
      encodeURIComponent(String(requestParameters['rolloutIdentifier'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: ServerApproveRolloutRequestToJSON(requestParameters['request']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseActionAckFromJSON(jsonValue),
    );
  }

  /**
   * Record a request to approve the given RequireApproval step of a rollout; a background reconciler applies it to every orchestra that has it
   * Approve a rollout step
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierApprovePut(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierApprovePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseActionAck> {
    const response =
      await this.operatorsOperatorNameRolloutsRolloutIdentifierApprovePutRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Get the full state of this rollout on a single cluster: every step with the cluster\'s own phase and timings, the state the cluster was told to take, and how far it got applying actions
   * Get a cluster rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsClusterNameGetRaw(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsClusterNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseClusterRollout>> {
    if (requestParameters['operatorName'] == null) {
      throw new runtime.RequiredError(
        'operatorName',
        'Required parameter "operatorName" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsClusterNameGet().',
      );
    }

    if (requestParameters['rolloutIdentifier'] == null) {
      throw new runtime.RequiredError(
        'rolloutIdentifier',
        'Required parameter "rolloutIdentifier" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsClusterNameGet().',
      );
    }

    if (requestParameters['clusterName'] == null) {
      throw new runtime.RequiredError(
        'clusterName',
        'Required parameter "clusterName" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsClusterNameGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/operators/{operatorName}/rollouts/{rolloutIdentifier}/cluster-rollouts/{clusterName}`;
    urlPath = urlPath.replace(
      `{${'operatorName'}}`,
      encodeURIComponent(String(requestParameters['operatorName'])),
    );
    urlPath = urlPath.replace(
      `{${'rolloutIdentifier'}}`,
      encodeURIComponent(String(requestParameters['rolloutIdentifier'])),
    );
    urlPath = urlPath.replace(
      `{${'clusterName'}}`,
      encodeURIComponent(String(requestParameters['clusterName'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseClusterRolloutFromJSON(jsonValue),
    );
  }

  /**
   * Get the full state of this rollout on a single cluster: every step with the cluster\'s own phase and timings, the state the cluster was told to take, and how far it got applying actions
   * Get a cluster rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsClusterNameGet(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsClusterNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseClusterRollout> {
    const response =
      await this.operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsClusterNameGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * List this rollout as it exists on each cluster, sorted by cluster name, one page at a time. Filters of different parameters combine with AND and repeated values of one parameter with OR, except condition where every given condition must match.
   * List cluster rollouts
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetRaw(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseClusterRolloutList>> {
    if (requestParameters['operatorName'] == null) {
      throw new runtime.RequiredError(
        'operatorName',
        'Required parameter "operatorName" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGet().',
      );
    }

    if (requestParameters['rolloutIdentifier'] == null) {
      throw new runtime.RequiredError(
        'rolloutIdentifier',
        'Required parameter "rolloutIdentifier" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit'];
    }

    if (requestParameters['cursor'] != null) {
      queryParameters['cursor'] = requestParameters['cursor'];
    }

    if (requestParameters['pendingActions'] != null) {
      queryParameters['pendingActions'] = requestParameters['pendingActions'];
    }

    if (requestParameters['propagationFailing'] != null) {
      queryParameters['propagationFailing'] =
        requestParameters['propagationFailing'];
    }

    if (requestParameters['stepPhase'] != null) {
      queryParameters['stepPhase'] = requestParameters['stepPhase'];
    }

    if (requestParameters['step'] != null) {
      queryParameters['step'] = requestParameters['step'];
    }

    if (requestParameters['cluster'] != null) {
      queryParameters['cluster'] = requestParameters['cluster'];
    }

    if (requestParameters['condition'] != null) {
      queryParameters['condition'] = requestParameters['condition'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/operators/{operatorName}/rollouts/{rolloutIdentifier}/cluster-rollouts`;
    urlPath = urlPath.replace(
      `{${'operatorName'}}`,
      encodeURIComponent(String(requestParameters['operatorName'])),
    );
    urlPath = urlPath.replace(
      `{${'rolloutIdentifier'}}`,
      encodeURIComponent(String(requestParameters['rolloutIdentifier'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseClusterRolloutListFromJSON(jsonValue),
    );
  }

  /**
   * List this rollout as it exists on each cluster, sorted by cluster name, one page at a time. Filters of different parameters combine with AND and repeated values of one parameter with OR, except condition where every given condition must match.
   * List cluster rollouts
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGet(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseClusterRolloutList> {
    const response =
      await this.operatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Get the fleet-wide detail for a single rollout, broken down per step
   * Get a rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierGetRaw(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseRollout>> {
    if (requestParameters['operatorName'] == null) {
      throw new runtime.RequiredError(
        'operatorName',
        'Required parameter "operatorName" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierGet().',
      );
    }

    if (requestParameters['rolloutIdentifier'] == null) {
      throw new runtime.RequiredError(
        'rolloutIdentifier',
        'Required parameter "rolloutIdentifier" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/operators/{operatorName}/rollouts/{rolloutIdentifier}`;
    urlPath = urlPath.replace(
      `{${'operatorName'}}`,
      encodeURIComponent(String(requestParameters['operatorName'])),
    );
    urlPath = urlPath.replace(
      `{${'rolloutIdentifier'}}`,
      encodeURIComponent(String(requestParameters['rolloutIdentifier'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseRolloutFromJSON(jsonValue),
    );
  }

  /**
   * Get the fleet-wide detail for a single rollout, broken down per step
   * Get a rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierGet(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseRollout> {
    const response =
      await this.operatorsOperatorNameRolloutsRolloutIdentifierGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Record a request to pause a rollout; a background reconciler applies it to every orchestra that has it
   * Pause a rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierPausePutRaw(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierPausePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseActionAck>> {
    if (requestParameters['operatorName'] == null) {
      throw new runtime.RequiredError(
        'operatorName',
        'Required parameter "operatorName" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierPausePut().',
      );
    }

    if (requestParameters['rolloutIdentifier'] == null) {
      throw new runtime.RequiredError(
        'rolloutIdentifier',
        'Required parameter "rolloutIdentifier" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierPausePut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/operators/{operatorName}/rollouts/{rolloutIdentifier}/pause`;
    urlPath = urlPath.replace(
      `{${'operatorName'}}`,
      encodeURIComponent(String(requestParameters['operatorName'])),
    );
    urlPath = urlPath.replace(
      `{${'rolloutIdentifier'}}`,
      encodeURIComponent(String(requestParameters['rolloutIdentifier'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseActionAckFromJSON(jsonValue),
    );
  }

  /**
   * Record a request to pause a rollout; a background reconciler applies it to every orchestra that has it
   * Pause a rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierPausePut(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierPausePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseActionAck> {
    const response =
      await this.operatorsOperatorNameRolloutsRolloutIdentifierPausePutRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Record a request to resume a paused rollout; a background reconciler applies it to every orchestra that has it
   * Resume a paused rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierResumePutRaw(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierResumePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseActionAck>> {
    if (requestParameters['operatorName'] == null) {
      throw new runtime.RequiredError(
        'operatorName',
        'Required parameter "operatorName" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierResumePut().',
      );
    }

    if (requestParameters['rolloutIdentifier'] == null) {
      throw new runtime.RequiredError(
        'rolloutIdentifier',
        'Required parameter "rolloutIdentifier" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierResumePut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/operators/{operatorName}/rollouts/{rolloutIdentifier}/resume`;
    urlPath = urlPath.replace(
      `{${'operatorName'}}`,
      encodeURIComponent(String(requestParameters['operatorName'])),
    );
    urlPath = urlPath.replace(
      `{${'rolloutIdentifier'}}`,
      encodeURIComponent(String(requestParameters['rolloutIdentifier'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseActionAckFromJSON(jsonValue),
    );
  }

  /**
   * Record a request to resume a paused rollout; a background reconciler applies it to every orchestra that has it
   * Resume a paused rollout
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierResumePut(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierResumePutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseActionAck> {
    const response =
      await this.operatorsOperatorNameRolloutsRolloutIdentifierResumePutRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Record a request to skip the cooldown of the given step and of every step before it; a background reconciler applies it to every orchestra that has it
   * Skip rollout step cooldowns
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierSkipCooldownPutRaw(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierSkipCooldownPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseActionAck>> {
    if (requestParameters['operatorName'] == null) {
      throw new runtime.RequiredError(
        'operatorName',
        'Required parameter "operatorName" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierSkipCooldownPut().',
      );
    }

    if (requestParameters['rolloutIdentifier'] == null) {
      throw new runtime.RequiredError(
        'rolloutIdentifier',
        'Required parameter "rolloutIdentifier" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierSkipCooldownPut().',
      );
    }

    if (requestParameters['request'] == null) {
      throw new runtime.RequiredError(
        'request',
        'Required parameter "request" was null or undefined when calling operatorsOperatorNameRolloutsRolloutIdentifierSkipCooldownPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/operators/{operatorName}/rollouts/{rolloutIdentifier}/skip-cooldown`;
    urlPath = urlPath.replace(
      `{${'operatorName'}}`,
      encodeURIComponent(String(requestParameters['operatorName'])),
    );
    urlPath = urlPath.replace(
      `{${'rolloutIdentifier'}}`,
      encodeURIComponent(String(requestParameters['rolloutIdentifier'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: ServerSkipCooldownRolloutRequestToJSON(
          requestParameters['request'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseActionAckFromJSON(jsonValue),
    );
  }

  /**
   * Record a request to skip the cooldown of the given step and of every step before it; a background reconciler applies it to every orchestra that has it
   * Skip rollout step cooldowns
   */
  async operatorsOperatorNameRolloutsRolloutIdentifierSkipCooldownPut(
    requestParameters: OperatorsOperatorNameRolloutsRolloutIdentifierSkipCooldownPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseActionAck> {
    const response =
      await this.operatorsOperatorNameRolloutsRolloutIdentifierSkipCooldownPutRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * List every rollout fleet-wide, across every operator and orchestra
   * List rollouts
   */
  async rolloutsGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseRolloutSummaryList>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/rollouts`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseRolloutSummaryListFromJSON(jsonValue),
    );
  }

  /**
   * List every rollout fleet-wide, across every operator and orchestra
   * List rollouts
   */
  async rolloutsGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseRolloutSummaryList> {
    const response = await this.rolloutsGetRaw(initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetStepPhaseEnum =
  {
    Pending: 'Pending',
    Waiting: 'Waiting',
    Transferring: 'Transferring',
    CoolingDown: 'CoolingDown',
    Completed: 'Completed',
  } as const;
export type OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetStepPhaseEnum =
  (typeof OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetStepPhaseEnum)[keyof typeof OperatorsOperatorNameRolloutsRolloutIdentifierClusterRolloutsGetStepPhaseEnum];
